import React from 'react'

import ResultsTemplate from '@new/__global/components/OmniSearch/components/ResultTemplates/ResultsTemplate'
import { BookingDetail } from '@new/domains/hotelTapeChart/components/HotelOmniSearch/components/BookingDetails'
import { HotelBookingProps } from '@new/domains/hotelTapeChart/components/HotelOmniSearch/HotelOmniSearch.types'

import { mountRouteUrl, openLink, ROUTES } from '@routes'

interface BookingResultsProps {
  bookings: HotelBookingProps[]
  onClick?: (booking: HotelBookingProps) => void
  searchTeam: string
  totalCount?: number
}

export const BookingsResults = ({
  bookings,
  onClick,
  searchTeam,
  totalCount = 0,
}: BookingResultsProps) => {
  const handleOnClick = (booking: HotelBookingProps) => {
    onClick
      ? onClick(booking)
      : openLink(mountRouteUrl(ROUTES.bookingInfo.path, { hash: booking.hash }))
  }

  return (
    <ResultsTemplate
      activeIndex={-1}
      baseUrl={ROUTES.bookings.path}
      data={bookings}
      onClick={handleOnClick}
      queryParamKey="filter"
      renderChildren={booking => <BookingDetail booking={booking} />}
      searchTerm={searchTeam}
      setIndex={() => {}}
      titlePrefix={bookings.length === 1 ? 'booking' : 'bookings'}
      totalCount={totalCount}
    />
  )
}
